<!-- Template for a new page -->
<template>
	<div class="d-flex flex-column flex h100">
		<navbar @login="doReturn" :refresh="refreshNav"></navbar>
		<div class="app">
			<!-- <sidenav></sidenav> -->
			<div id="content" v-if="item" class="app-content box-shadow-3">
				<!-- Optional navbar at top of page -->
				<div class="navbar navbar-light bg-light">
					<div class="d-flex flex-row align-items-center">
						<div class="d-flex flex-row align-content-center">
							<i
								v-if="driver.icon"
								class="no-select material-icons"
								style="font-size: 20px; line-height: 24px"
								v-tippy
								:title="driver.name"
								>{{ driver.icon }}</i
							>
							<i
								v-if="driver.fa_icon"
								class="no-select fas"
								:class="{ [driver.fa_icon]: true }"
								style="font-size: 16px; line-height: 24px"
								v-tippy
								:title="driver.name"
								>{{ driver.icon }}</i
							>
							<span v-if="alertName" class="mx-1">
								{{ alertName }}
								<i class="far fa-angle-right ml-1"></i>
							</span>
							<span v-if="response && !responseOwner" class="mx-1">{{ item.name }}</span>
							<span v-if="response && responseOwner" class="mx-1">{{ item.name }}:</span>
							<strong v-if="response && responseOwner">{{ student.full_name }}</strong>
							<strong v-if="!response">Loading</strong>
						</div>
					</div>

					<div class="d-flex flex-row align-items-center">
						<div
							v-if="item.show_timeout_timer"
							class="px-2 mr-2 slow-color"
							v-b-popover
							id="timeout"
							:class="timeoutColor(timeout)"
							style="padding-top: 2px"
						>
							<i class="fas fa-clock fa-lg"></i>
						</div>
						<b-popover
							v-if="item.show_timeout_timer"
							target="#timeout"
							triggers="hover"
							placement="leftbottom"
						>
							<template slot="title">
								<span class="px-3 text-center">Timeout</span>
							</template>
							<div
								class="d-flex flex-row align-items-baseline justify-content-center slow-color"
								:class="timeoutColor(timeout)"
							>
								<h6 class="_600 mb-0">{{ fs.shortDurationMinutes(timeout) }}</h6>
								<span class="text-muted mx-small">m</span>
								<h6 class="_600 mb-0">{{ fs.shortDurationSeconds(timeout) }}</h6>
								<span class="text-muted mx-small">s</span>
							</div>
						</b-popover>
						<div v-if="score_count > 0" class="mr-3">
							Scored:
							<strong>{{ score_count }}</strong>
						</div>
						<a
							v-if="user.role.allow_print && response"
							@click="print(response)"
							target="_blank"
							class="exit-button b-l ml-0 mr-0 d-flex flex-column justify-content-center"
							v-tippy="{ placement: 'bottom' }"
							title="Print"
						>
							<i class="fas fa-lg fa-print"></i>
						</a>
						<div class="exit-button b-l ml-0" @click="doReturn()">
							<a class="_600">Exit</a>
						</div>
					</div>
				</div>

				<div class="content" v-if="item">
					<div
						class="viewer-container"
						:class="{
							'show-sidenav': showRubric,
							'show-resources': showResources,
							'show-notes': showNotes,
							'show-res': showRes,
						}"
					>
						<!-- The media area -->
						<div
							class="viewer-viewport"
							:class="{ trans: !resizing }"
							id="media"
							:style="{ right: viewportRight, bottom: viewportBottom }"
						>
							<div
								v-if="
									response &&
									item.use_considerations &&
									((delivery && delivery.item_notes) || response.scoring_note || addingScoringNote)
								"
								class="card top-box border-danger border-2 mb-2"
							>
								<div class="d-flex flex-row">
									<h6 class="flex _600">Scoring Considerations</h6>
									<a
										v-if="!response.scoring_note && !addingScoringNote && responseOwner"
										class="btn-round-subtle"
										v-tippy
										:title="scoringNoteTooltip"
										@click="editScoringNote"
									>
										<i class="fas fa-plus" />
									</a>
								</div>
								<ul class="notes-list">
									<li v-if="delivery && delivery.item_notes" v-html="delivery.item_notes"></li>
									<li v-if="response.scoring_note && responseOwner">
										<div class="d-flex flex-row">
											<div class="flex" v-html="response.scoring_note"></div>
											<a
												class="btn-round-subtle"
												v-tippy
												title="Remove"
												@click="removeScoringNote"
											>
												<i class="fas fa-trash" />
											</a>
										</div>
									</li>
									<li
										v-if="response.scoring_note && !responseOwner"
										v-html="response.scoring_note"
									></li>
								</ul>
								<div v-if="addingScoringNote">
									<RichText
										:initial="scoringNoteInit"
										:text.sync="scoringNote"
										:options="{ height: 100 }"
										class="mb-0"
									></RichText>
									<div class="d-flex flex-row justify-content-end">
										<button class="btn btn-primary" @click="addingScoringNote = false">
											Cancel
										</button>
										<button class="btn btn-success ml-2" @click="addScoringNote">Save</button>
									</div>
								</div>
							</div>
							<media
								v-show="view == 0"
								:response="response0"
								:item="item"
								:chan="chan"
								@setup="setupFinished(0)"
							></media>
							<media
								v-show="view == 1"
								:response="response1"
								:item="item"
								:chan="chan"
								@setup="setupFinished(1)"
							></media>
						</div>

						<!-- Personal notes -->
						<div
							v-if="item.notes_enabled"
							class="notes-container px-2"
							:class="{ trans: !resizing }"
							:style="{ right: viewportRight, bottom: notesBottom, height: notesHeight }"
						>
							<personal-note :item="item" :user="user" />
						</div>

						<!-- Notes split resize -->
						<div
							v-if="item.notes_enabled"
							class="resize-btn-h toggles-overlay"
							@mousedown="notesResizeStart"
							@mouseup="notesResizeEnd"
							@touchstart="notesResizeStart"
							@touchend="notesResizeEnd"
							id="notes-resize"
							:class="{ show: toggle_hit || resizing, trans: !resizing }"
							:style="{ bottom: notesResizeBottom, left: notesResizeLeft }"
						>
							<i class="material-icons no-select">drag_indicator</i>
						</div>

						<div
							v-if="item.notes_enabled"
							class="notes-collapse-btn bottom-btn"
							@click="toggleNotes()"
							id="notes-toggle"
							:class="{ show: toggle_hit || resizing, trans: !resizing }"
							:style="{ left: '8px', bottom: viewportBottom }"
						>
							<i
								v-if="!showNotes"
								v-tippy="{ placement: 'top' }"
								title="Show Personal Notes"
								class="material-icons"
								>open_in_browser</i
							>
							<i
								v-if="showNotes"
								v-tippy="{ placement: 'top' }"
								title="Hide Personal Notes"
								class="material-icons"
								>keyboard_arrow_down</i
							>
						</div>

						<ViewerControls
							:chan="chan"
							:item="item"
							:showNotes="showNotes"
							class="controls-overlay trans"
						></ViewerControls>

						<!-- Resources pane -->
						<div
							class="resources"
							:class="{ trans: !resizing }"
							id="resources"
							:style="{ right: resourcesRight, width: resourcesWidth }"
						>
							<div class="r-controls-overlay trans dropright">
								<button
									class="md-btn md-fab md-fab-sm mb-2 theme"
									v-tippy
									title="Resources"
									data-toggle="dropdown"
									aria-expanded="false"
								>
									<i class="far fa-info-circle"></i>
								</button>
								<div class="dropdown-menu">
									<div v-if="!item.resources || item.resources.length == 0">
										<h6 class="text-muted text-center">No Resources</h6>
									</div>
									<a
										v-if="item.resources && item.resources.length > 0"
										v-for="res in item.resources"
										:key="res.id"
										class="dropdown-item theme-hover d-flex flex-row align-items-center"
										@click="pickResource(res)"
										:class="{ active: pickedResource && res.id == pickedResource.id }"
									>
										<i
											class="fa-lg"
											:class="{
												[pickedResource && res.id == pickedResource.id ? 'fas' : 'far']: true,
												[fs.mimeTypeIcon(res.mime_type)]: true,
											}"
										></i>
										<span class="flex">{{ res.name }}</span>
										<i
											class="far ml-3 fa-external-link text-very-muted float-right"
											style="margin-right: -16px"
											@click="viewResource(res)"
											v-tippy
											title="Open in new window"
										></i>
									</a>

									<hr v-if="exemplarTraits.length" />

									<div class="dropdown-submenu" v-if="exemplarTraits.length">
										<a class="dropdown-item" :class="{ active: pickedExemplar }">
											<i
												class="fa-lg fa-file-invoice"
												:class="{ [pickedExemplar ? 'fas' : 'far']: true }"
											></i
											>Exemplars
											<i
												class="fas fa-angle-right float-right"
												style="margin-right: -16px; margin-top: 4px"
											></i>
										</a>
										<div class="dropdown-menu">
											<div
												class="dropdown-submenu"
												v-for="trait in exemplarTraits"
												:key="trait.id"
											>
												<a
													class="dropdown-item"
													:class="{
														active: pickedExemplar && trait.id == pickedExemplar.trait_id,
													}"
												>
													<i class="fas fa-angle-left" />
													{{ trait.name }}
												</a>
												<div class="dropdown-menu pull-left">
													<a
														class="dropdown-item d-flex flex-row align-items-center"
														:class="{
															active:
																pickedExemplar &&
																trait.id == pickedExemplar.trait_id &&
																spd.val == pickedExemplar.val,
														}"
														v-for="(spd, i) in trait.score_point_descriptors"
														:key="i"
														@click="pickExemplar(trait, spd)"
													>
														<span class="flex">Score: {{ spd.val }}</span>
													</a>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<!-- <div class="nav-active-bg tabs-overlay trans mx-5">
								<ul class="nav nav-tabs justify-content-center b-l">
									<li v-for="resource in item.resources" :key="resource.id" class="nav-item">
										<a class="nav-link px-2 py-1" @click="pickResource(resource)" :class="{'active': pickedResource && pickedResource.id == resource.id, 'show': pickedResource && pickedResource.id == resource.id}"
										    v-tippy="{placement: 'bottom', theme: 'popover'}" :title="resource.name">
											{{resource.name}}
										</a>
									</li>
								</ul>
							</div>-->
							<div class="resources-container">
								<resource
									v-if="pickedResource"
									:resource="pickedResource"
									:item="item"
									@open="viewResource"
								/>
								==== Resources go here ====
								<exemplar-list
									v-if="pickedExemplar"
									:exemplars="pickedExemplar.exemplars"
									@openExemplar="openExemplar"
								/>
							</div>
						</div>

						<!-- Rubric Sidenav -->
						<div
							class="viewer-sidenav trans pst-rlt"
							id="sidenav"
							:style="{ width: sidenavWidth + 'px', right: sidenavRight + 'px' }"
						>
							<!-- Rubric & previous scores -->
							<div
								v-if="showRubricComponent"
								v-show="!showEscalateUI"
								class="h-100"
								:class="{ prev: driver.showScores(this.item) || hasFlag }"
							>
								<div
									class="d-flex flex-column scroll-y"
									style="margin-right: -10px; padding-right: 10px"
								>
									<!-- Rangefinding comment -->
									<div v-if="showComment">
										<div class="d-flex flex-row align-items-center mb-1">
											<div class="flex">Comment:</div>
											<button class="btn btn-primary" @click="showComment = false">Remove</button>
										</div>
										<RichText
											:initial="initComment"
											:text.sync="comment"
											:options="{ height: 150 }"
											class="mb-0"
										></RichText>
									</div>

									<div v-if="!showScoreSubmit" class="d-flex flex-row flex-wrap">
										<multi-score
											:scores="response.scores"
											:rubric="item.rubric"
											class="mb-2"
										></multi-score>
										<template v-if="studentFeedbacks && studentFeedbacks.length > 0">
											<div
												v-for="(feedback, i) in studentFeedbacks"
												:key="feedback.id"
												class="box mb-0 w-100"
												:class="{ 'mt-2': i > 0 }"
											>
												<div class="text-right text-muted">
													<span
														v-tippy
														:title="`Feedback from ${scoreTypeString(feedback)} Scorer`"
													>
														Feedback:
														{{ scoreTypeString(feedback) }}
														<i
															class="fas fa-fw mr-1"
															:class="{ [scoreTypeIcon(feedback)]: true }"
														/>
													</span>
												</div>
												<div class="mb-2 p-2 bg-white" v-html="feedback.text"></div>
											</div>
										</template>
										<hr class="w-100" />
									</div>

									<!-- Messages -->
									<div v-for="message in messages" :key="message.id">
										<div class="float-right">
											{{ message.user ? message.user.full_name : "" }}
											<span class="text-muted">{{ fs.medDate(message.created_at) }}</span>
										</div>
										<span v-tippy :title="`Comment by ${scoreTypeString(message)} Scorer`">
											<i class="fas fa-fw mr-1" :class="{ [scoreTypeIcon(message)]: true }" />
											<strong>{{ scoreTypeString(message) }}</strong>
										</span>
										<div class="mt-1 mb-2 p-2 bg-white" v-html="message.text"></div>
									</div>

									<div v-if="item.use_comments && (showScoreSubmit || user.role.comment_on_complete)">
										<div class="my-1">
											<span
												v-tippy="{ placement: 'bottom-start' }"
												title="This comment will be visible only to other scorers after they've submitted their own score"
												>Inter-scorer Comment:</span
											>
										</div>
										<RichText
											:initial="initComment"
											:text.sync="comment"
											:refresh="commentReset"
											:options="{ height: 150 }"
											class="mb-0"
										></RichText>
									</div>

									<div v-if="item.use_feedback && showScoreSubmit">
										<div class="my-1">
											<span
												v-tippy="{ placement: 'bottom-start' }"
												title="This comment will be shown to the student along with their scores"
												>Student Feedback:</span
											>
										</div>
										<RichText
											:initial="initFeedback"
											:text.sync="feedback"
											:refresh="feedbackReset"
											:options="{ height: 150 }"
											class="mb-0"
										></RichText>
									</div>

									<div v-if="showScoreSubmit" class="flex d-flex flex-row justify-content-start">
										<div style="width: 230px" v-if="driver.showScores(this.item)">
											<score
												v-for="score in response.scores"
												@on-reset="resetScorePrompt"
												:reset="false"
												:key="score.id"
												:score="score"
												:rubric="item.rubric"
												class="my-2"
											></score>
										</div>

										<div style="display: inline; width: 430px">
											<rubric
												:outer-rubric="item.rubric"
												:chooseRes="item.resolution_choose_score && driver.chooseKeepScore"
												:initScore="initScore"
												:resFirstScore="resFirstScore"
												:resSecondScore="resSecondScore"
												:reset="reset"
												:score.sync="score"
												:complete.sync="rubricComplete"
												@exemplar="pickExemplarFromRubric"
												:selectingTraits="showExemplarUI"
												@exemplaryTraits="syncExemplaryTraits"
											></rubric>

											<div class="d-flex flex-row">
												<div style="width: 235px">
													<!-- Disabled Submit w/ tooltip -->
													<div
														v-if="!showFlagUI && !allowViewedAll && !(nav && nav.next)"
														style="height: 56px; width: 56px; border-radius: 50%"
														class="float-right mt-2 mb-2"
														v-tippy="{ placement: 'bottom' }"
														title="You must view<br />the whole response<br />before submitting"
													>
														<button disabled class="md-btn md-fab success">
															<i class="material-icons pt-2">check</i>
														</button>
													</div>

													<!-- Submit -->
													<button
														v-if="!showFlagUI && allowViewedAll && !(nav && nav.next)"
														@click="submit()"
														v-tippy="{ delay: [500, 0], placement: 'bottom' }"
														title="Submit Score"
														:disabled="!rubricComplete"
														class="float-right mt-2 md-btn md-fab success mb-2"
													>
														<i class="material-icons pt-2">check</i>
													</button>

													<button
														v-if="canComment && !showComment"
														@click="showComment = true"
														v-tippy="{ delay: [500, 0] }"
														title="Include Comment"
														:disabled="!user.role.page_rf_setup && !rubricComplete"
														class="md-btn md-fab md-fab-sm warn mt-3"
													>
														<i class="fas fa-comment-plus" style="font-size: 1.5rem"></i>
													</button>

													<button
														v-if="
															item.use_considerations &&
															responseOwner &&
															!(response.scoring_note || delivery.item_notes)
														"
														@click="editScoringNote"
														v-tippy
														:title="scoringNoteTooltip"
														class="md-btn md-fab md-fab-sm warn mt-3"
													>
														<i class="fas fa-plus" style="font-size: 1.5rem"></i>
													</button>

													<button
														v-if="showExemplarEscalate"
														@click="openExemplarUI()"
														v-tippy
														:title="escalateExemplarTooltip"
														:disabled="!user.role.page_rf_setup && !rubricComplete"
														class="ml-2 md-btn md-fab md-fab-sm primary mt-3"
													>
														<i class="fas fa-atlas" style="font-size: 1.5rem"></i>
													</button>

													<div v-if="showEscalate || showRFEscalate" class="d-flex flex-row">
														<button
															v-if="showEscalate"
															@click="escalate()"
															v-tippy="{ delay: [500, 0] }"
															title="Escalate Response"
															:disabled="!rubricComplete"
															class="md-btn md-fab md-fab-sm info mt-3"
														>
															<i class="material-icons pt-2">turned_in_not</i>
														</button>
														<button
															v-if="showRFEscalate"
															@click="sendRFEscalation()"
															v-tippy="{ delay: [500, 0] }"
															title="Add to Rangefinding"
															:disabled="!user.role.page_rf_setup && !rubricComplete"
															class="ml-2 md-btn md-fab md-fab-sm warn mt-3"
														>
															<i
																class="fas fa-drafting-compass"
																style="font-size: 1.5rem"
															></i>
														</button>
														<br />
													</div>
													<button
														v-if="item.alerts && item.alerts.length > 0 && !showFlagUI"
														@click="flag()"
														v-tippy="{ delay: [500, 0] }"
														title="Flag Response"
														class="md-btn md-fab md-fab-sm danger mt-3"
													>
														<i class="material-icons pt-2">warning</i>
													</button>
												</div>
												<div style="width: 195px">
													<button
														v-if="showExemplarUI"
														@click="escalateExemplar()"
														:disabled="!rubricComplete || pickedExemplaryTraits.length == 0"
														class="btn mt-3 float-right"
														:class="{
															[!rubricComplete || pickedExemplaryTraits.length == 0
																? 'btn-secondary'
																: 'success']: true,
														}"
													>
														Escalate
													</button>
													<button
														v-if="showExemplarUI"
														class="btn btn-primary ml-3 mt-3"
														@click="showExemplarUI = false"
													>
														Cancel
													</button>
												</div>
											</div>

											<!-- Flag UI -->
											<div v-if="showFlagUI" class="mt-3 pb-3">
												<div>
													<div class="form-group">
														<label>Flag</label>
														<v-select
															:options="alerts"
															v-model="flagAlert"
															class="bg-white"
															:searchable="false"
														/>
													</div>
													<div class="form-group">
														<label>Flag Reason</label>
														<textarea
															class="form-control"
															rows="5"
															v-model="flagReason"
														></textarea>
													</div>
												</div>

												<button class="btn btn-primary" @click="showFlagUI = false">
													Cancel
												</button>
												<button
													:class="{ theme: canDoFlag }"
													:disabled="!canDoFlag"
													class="btn btn-secondary float-right"
													@click="submitFlag()"
												>
													Flag
												</button>
												<div
													v-if="flagAlert && flagAlert.requires_score && !canDoFlag"
													class="text-muted text-xs text-right mt-2"
												>
													This flag requires a complete score
												</div>
												<div
													v-if="flagAlert && flagAlert.requires_score && canDoFlag"
													class="text-muted text-xs text-right mt-2"
												>
													Score will be applied with flag
												</div>
											</div>
										</div>
									</div>

									<div v-if="!showScoreSubmit" class="flex d-flex flex-row justify-content-end">
										<span class="flex">
											<button
												v-if="
													item.use_considerations &&
													responseOwner &&
													!(response.scoring_note || delivery.item_notes || addingScoringNote)
												"
												@click="editScoringNote"
												v-tippy
												:title="scoringNoteTooltip"
												class="md-btn md-fab md-fab-xs danger mt-3"
											>
												<i class="fas fa-plus" style="font-size: 1rem"></i>
											</button>
										</span>
										<button
											v-if="user.role.comment_on_complete"
											@click="addComment()"
											:disabled="!comment"
											v-tippy="{ delay: [500, 0], placement: 'bottom' }"
											title="Add Comment"
											class="float-right mt-2 md-btn md-fab success mb-2"
										>
											<i class="material-icons pt-2">check</i>
										</button>
										<button
											v-if="driver.nextWithoutSubmit"
											@click="getNext()"
											v-tippy="{ delay: [500, 0], placement: 'bottom' }"
											title="Next"
											class="float-right ml-2 mt-2 md-btn md-fab primary mb-2"
										>
											<i class="material-icons pt-2">arrow_forward</i>
										</button>
									</div>

									<!-- Navigation footer -->
									<div v-if="nav" class="b-t set-nav-footer p-2">
										<div class="_600">{{ nav.set_name }}</div>
										<hr class="my-2" />
										<div class="d-flex flex-row align-items-center">
											<button
												@click="maybeSubmitThenNav(nav.prev)"
												class="btn btn-sm"
												:class="{ theme: nav.prev }"
												:disabled="!nav.prev"
											>
												<i class="fas fa-arrow-left"></i>
											</button>
											<div class="flex text-center">{{ nav.current }} out of {{ nav.total }}</div>
											<button
												@click="maybeSubmitThenNav(nav.next)"
												class="btn btn-sm"
												:class="{ theme: nav.next }"
												:disabled="!nav.next"
											>
												<i class="fas fa-arrow-right"></i>
											</button>
										</div>
									</div>
								</div>
							</div>

							<!-- Validity Feedback -->
							<div v-if="showValFeedback" class>
								<div class="row mt-2 mb-0">
									<div class="col-sm-12">
										<div class="box mb-0">
											<div v-if="valCorrect" class="box-header success">
												<h3>Correct Validity Score!</h3>
											</div>
											<div v-if="!valCorrect" class="box-header danger">
												<h3>Incorrect Validity Score!</h3>
											</div>
											<div class="box-body">
												<p class="m-0">Please review the feedback and click OK to continue.</p>
											</div>
										</div>
									</div>
								</div>
								<div class="row mt-2">
									<div class="col-sm-12">
										<score
											:score="score"
											:rubric="item.rubric"
											:compareScore="response.true_score"
										/>
									</div>
								</div>
								<div class="row mt-2">
									<div class="col-sm-12">
										<div class="box h100">
											<div class="box-header light">
												<h3>Feedback:</h3>
											</div>
											<div class="box-body">
												<p class="m-0" v-html="response.feedback"></p>
											</div>
										</div>
									</div>
								</div>
								<button class="btn theme float-right mt-2" @click="qcContinue()">OK</button>
							</div>

							<!-- Failed Validity MSG -->
							<div v-if="showValEndMsg" class>
								<div class="row mt-2 mb-0">
									<div class="col-sm-12">
										<div class="box mb-0">
											<div class="box-header danger">
												<h3>Validity Lockout.</h3>
											</div>
											<div class="box-body">
												<p class="m-0">
													Unfortunitely, you fell below the required validity threshold.
												</p>
												<p class="m-0">
													You have been temporarily locked out of scoring. Contact your
													supervisor for further instuctions.
												</p>
											</div>
										</div>
									</div>
								</div>

								<button class="btn theme float-left mt-2" @click="doReturn()">Continue</button>
							</div>

							<!-- Failed Calibration MSG -->
							<div v-if="showCalEndMsg" class>
								<div class="row mt-2 mb-0">
									<div class="col-sm-12">
										<div class="box mb-0">
											<div class="box-header danger">
												<h3>Calibration Lockout.</h3>
											</div>
											<div class="box-body">
												<p class="m-0">
													Unfortunitely, you fell below the required threshold for
													calibration.
												</p>
												<p class="m-0">
													You have been temporarily locked out of scoring. Contact your
													supervisor for further instuctions.
												</p>
											</div>
										</div>
									</div>
								</div>

								<button class="btn theme float-left mt-2" @click="doReturn()">Continue</button>
							</div>

							<!-- Qual Start MSG -->
							<div v-if="showQualStartMsg" class>
								<div class="row mt-2 mb-0">
									<div class="col-sm-12">
										<div class="box mb-0">
											<div class="box-header success">
												<h3>Qualification Set</h3>
											</div>

											<div class="box-body">
												<p class="m-0">
													You are scoring a qualification set. Your scores will be evaluated
													for accuracy and scoring proficiency.
												</p>
												<p class="m-0">Click OK to continue.</p>
											</div>
										</div>
									</div>
								</div>

								<button class="btn theme float-right mt-2" @click="showQualStartMsg = false">OK</button>
							</div>

							<!-- Qual End MSG -->
							<div v-if="showQualEndMsg" class>
								<div class="row mt-2 mb-0">
									<div class="col-sm-12">
										<div class="box mb-0">
											<div v-if="qualPassed" class="box-header success">
												<h3>You're Qualified!</h3>
											</div>
											<div v-if="!qualPassed" class="box-header danger">
												<h3>End of Qualification</h3>
											</div>
											<div v-if="qualPassed" class="box-body">
												<p class="m-0">You successfully qualified to score this item.</p>
												<p class="m-0">
													Click Review to review your qualification scores, or Continue to
													begin scoring.
												</p>
											</div>
											<div v-if="!qualPassed" class="box-body">
												<p class="m-0">Unfortunitely, you did not qualify at this time.</p>
												<p class="m-0">
													Click Review to review your scores and contact your supervisor for
													further instuctions.
												</p>
											</div>
										</div>
									</div>
								</div>

								<button v-if="qualPassed" class="btn theme float-left mt-2" @click="qcContinue()">
									Continue
								</button>
								<a
									class="btn primary float-right mt-2"
									type="link"
									:href="`#/qc_set_report/${this.response.qc_set_id}`"
									>Review</a
								>
							</div>

							<!-- Escalate UI -->
							<div v-if="showEscalateUI" class="pb-3">
								<div>
									<div class="form-group" v-if="!rubricComplete || escalateRangefinding">
										<label>Escalate:</label>
									</div>
									<div class="form-group" v-if="rubricComplete && !escalateRangefinding">
										<label>Feedback:</label>
										<RichText :text.sync="escalationFeedback"></RichText>
									</div>
									<div class="row m-0 mb-3">
										<div v-if="rubricComplete && !escalateRangefinding" class="col s6">
											<score
												class="mb-2"
												:rubric="item.rubric"
												:score="escalationScore"
												:type="20"
											></score>
										</div>
										<div class="col s6">
											<div v-if="user.role.can_escalate" class="checkbox form-group">
												<label
													class="md-check pr-2"
													:class="{ 'text-muted': !rubricComplete }"
													v-tippy="{ placement: 'right' }"
													:title="rubricComplete ? '' : 'You must apply a score first'"
												>
													<input
														type="checkbox"
														@change="updateEscalationSelections()"
														:disabled="!rubricComplete"
														v-model="escalateTraining"
													/>
													<i class="theme"></i> Training
												</label>
											</div>
											<div v-if="user.role.can_escalate" class="checkbox form-group">
												<label
													class="md-check pr-2"
													:class="{ 'text-muted': !rubricComplete }"
													v-tippy="{ placement: 'right' }"
													:title="rubricComplete ? '' : 'You must apply a score first'"
												>
													<input
														type="checkbox"
														@change="updateEscalationSelections()"
														:disabled="!rubricComplete"
														v-model="escalateQual"
													/>
													<i class="theme"></i> Qualification
												</label>
											</div>
											<div v-if="user.role.can_escalate" class="checkbox form-group">
												<label
													class="md-check pr-2"
													:class="{ 'text-muted': !rubricComplete }"
													v-tippy="{ placement: 'right' }"
													:title="rubricComplete ? '' : 'You must apply a score first'"
												>
													<input
														type="checkbox"
														@change="updateEscalationSelections()"
														:disabled="!rubricComplete"
														v-model="escalateValidity"
													/>
													<i class="theme"></i> Validity
												</label>
											</div>
											<div v-if="user.role.can_escalate" class="checkbox form-group">
												<label
													class="md-check pr-2"
													:class="{ 'text-muted': !rubricComplete }"
													v-tippy="{ placement: 'right' }"
													:title="rubricComplete ? '' : 'You must apply a score first'"
												>
													<input
														type="checkbox"
														@change="updateEscalationSelections()"
														:disabled="!rubricComplete"
														v-model="escalateCalibration"
													/>
													<i class="theme"></i> Calibration
												</label>
											</div>
										</div>
									</div>
								</div>

								<button class="btn btn-primary" @click="showEscalateUI = false">Cancel</button>
								<button
									:disabled="!escalationDestinations.length"
									:class="{ theme: escalationDestinations.length }"
									class="btn btn-secondary float-right"
									@click="sendEscalation()"
								>
									Escalate
								</button>
							</div>

							<!-- QC True Score UI -->
							<div v-if="driver.sidebarType() == 'qc_true_score' && response" class="pb-3">
								<div>
									<div class="form-group">
										<label>Feedback:</label>
										<RichText :initial="qcTrueFeedback" :text.sync="response.feedback"></RichText>
									</div>
									<rubric
										:outer-rubric="item.rubric"
										:reset="reset"
										:score.sync="score"
										:complete.sync="rubricComplete"
									></rubric>
								</div>

								<button class="btn btn-primary" @click="doReturn()">Cancel</button>
								<button
									v-if="!showFlagUI"
									@click="submit()"
									title="Submit Score"
									:disabled="!rubricComplete"
									class="btn success float-right mt-2"
								>
									Save
								</button>
							</div>

							<!-- Auditing Sidenav -->
							<div
								v-if="
									(driver.sidebarType() == 'auditing' || driver.sidebarType() == 'flag_queue') &&
									response
								"
							>
								<h6 class="text-center mb-0 mt-2">
									<strong>State:</strong>
									{{ fs.responseState(response.state) }}
								</h6>
								<hr class="my-3" />

								<div v-if="isWithheld" class="btn-group btn-block w-100">
									<button @click="releaseFlag" class="btn btn-danger btn-block mx-auto">
										Release
									</button>
									<button
										v-if="canReleaseAndScore"
										@click="releaseFlagAndScore"
										class="btn btn-danger"
										v-tippy
										title="Release & Score"
									>
										<i class="far fa-check"></i>
									</button>
								</div>

								<div v-if="hasFlag" :class="{ 'mt-3': isWithheld }">
									<div v-for="flag in flags" :key="flag.id">
										<!-- Flag object -->
										<flag
											v-if="updatingAuditFlag != flag.id"
											:flag="flag"
											:item="item"
											@delete="deleteFlag"
											@review="markFlagReviewed"
											@update="auditFlag(flag)"
											class="mb-2"
										/>

										<!-- Edit flag -->
										<div v-if="updatingAuditFlag == flag.id" class="my-3">
											<div>
												<div>
													<label
														class="float-right"
														v-tippy
														:title="user.first_name + ' ' + user.last_name"
														>{{ user.scorer_id }}</label
													>
													<label>
														<i class="fas fa-lg fa-fw fa-flag"></i>
														Flag:
													</label>
												</div>
												<div></div>
											</div>
											<div class="form-group">
												<label>Flag Code</label>
												<config-select
													:options="alertsScorable"
													v-model="flagAlert"
													class="bg-white"
													:searchable="false"
												/>
											</div>
											<div class="form-group">
												<label>Flag Reason</label>
												<textarea class="form-control" rows="5" v-model="flagReason"></textarea>
											</div>

											<button class="btn btn-primary" @click="cancelAuditFlag">Cancel</button>
											<button class="btn theme float-right" @click="updateAuditFlag(flag)">
												Update
												<loading v-if="flag.updating" type="icon" />
											</button>
										</div>
									</div>
								</div>

								<button
									v-if="driver.sidebarType() == 'flag_queue'"
									class="btn btn-block mx-auto mt-3"
									@click="flagQueueAdvance"
									:disabled="!driver.canAdvance(flags, params)"
									:class="{
										[driver.canAdvance(flags, params) ? 'btn-success' : 'btn-secondary']: true,
									}"
								>
									Next
								</button>

								<hr v-if="hasFlag || isWithheld" class="my-3" />

								<p class="text-center text-muted" v-if="!response.scores.length">No Scores</p>
								<button
									v-if="canScore(response)"
									@click="auditScore()"
									class="btn theme btn-block mx-auto mb-3"
									style="width: 208x"
								>
									Score Response
									<i class="far fa-check"></i>
								</button>

								<div
									v-if="response.locked && canUnlockAndScore"
									class="btn-group mb-3 btn-block"
									style="width: 208x"
								>
									<button @click="unlock()" class="btn theme btn-block mx-auto">
										Unlock Response
										<i class="far fa-fw fa-unlock"></i>
									</button>
									<button @click="auditScore()" class="btn theme" v-tippy title="Unlock & Score">
										<i class="far fa-check"></i>
									</button>
								</div>

								<template v-for="score in response.scores">
									<score
										@on-reset="resetScorePrompt"
										:reset="true"
										:key="score.id"
										:score="score"
										:rubric="item.rubric"
										class="mb-2"
									></score>

									<div v-if="score.student_feedback" :key="`sf-${score.id}`" class="box mb-2 w-100">
										<div class="text-right text-muted">
											<span v-tippy :title="`Feedback from ${scoreTypeString(score)} Scorer`">
												Feedback:
												{{ scoreTypeString(score) }}
												<i class="fas fa-fw mr-1" :class="{ [scoreTypeIcon(score)]: true }" />
											</span>
										</div>
										<div class="mb-2 p-2 bg-white" v-html="score.student_feedback"></div>
									</div>
								</template>

								<hr v-if="messages && messages.length > 0" class="mt-4 w-100" />
								<div v-for="message in messages" :key="message.id">
									<div class="float-right">
										{{ message.user ? message.user.full_name : "" }}
										<span class="text-muted">{{ fs.medDate(message.created_at) }}</span>
									</div>
									<span v-tippy :title="`Comment by ${scoreTypeString(message)} Scorer`">
										<i class="fas fa-fw mr-1" :class="{ [scoreTypeIcon(message)]: true }" />
										<strong>{{ scoreTypeString(message) }}</strong>
									</span>
									<div class="mt-1 mb-2 p-2 bg-white" v-html="message.text"></div>
								</div>
							</div>
						</div>

						<!-- Rubric Toggle -->
						<div
							class="rubric-collapse-btn side-btn toggles-overlay"
							@click="toggleRubric()"
							id="rubric-toggle"
							:class="{ show: toggle_hit || resizing, trans: !resizing }"
							:style="{ right: rubricCollapseRight }"
						>
							<i
								v-if="!showRubric"
								v-tippy="{ placement: 'left' }"
								title="Show Scoring Controls"
								class="material-icons"
								>check</i
							>
							<i
								v-if="showRubric"
								v-tippy="{ placement: 'left' }"
								title="Hide Scoring Controls"
								class="material-icons"
								>keyboard_arrow_right</i
							>
						</div>

						<!-- Resources Toggle -->
						<div
							v-if="item.resources.length > 0"
							class="resource-collapse-btn side-btn toggles-overlay"
							@click="toggleResource()"
							id="resource-toggle"
							:class="{ show: toggle_hit || resizing, trans: !resizing }"
							:style="{ right: resourceCollapseRight }"
						>
							<i
								v-if="showResources"
								v-tippy="{ placement: 'left' }"
								title="Hide Resources"
								class="material-icons"
								>keyboard_arrow_right</i
							>
							<i
								v-if="!showResources"
								v-tippy="{ placement: 'left' }"
								title="Show Item Resources"
								class="material-icons"
								style="font-size: 20px; padding: 2px"
								>book</i
							>
						</div>

						<!-- Resource split resize -->
						<div
							class="resize-btn toggles-overlay"
							@mousedown="resourceResizeStart"
							@mouseup="resourceResizeEnd"
							@touchstart="resourceResizeStart"
							@touchend="resourceResizeEnd"
							id="resource-resize"
							:class="{ show: toggle_hit || resizing, trans: !resizing }"
							:style="{ right: resourceResizeRight }"
						>
							<i class="material-icons no-select">drag_indicator</i>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Modals for Auditing functionality -->
		<div class="modal" id="resetConfirm" data-backdrop="static" data-keyboard="false">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header red">
						<h5>Reset Score?</h5>
					</div>
					<div class="modal-body text-center" v-if="resetting_score">
						<score class="mx-auto mb-2" :score="resetting_score" :rubric="item.rubric"></score>
					</div>
					<div class="modal-footer">
						<button class="btn btn-flat" data-dismiss="modal">Cancel</button>
						<button @click="resetScore(resetting_score)" class="btn btn-flat red" data-dismiss="modal">
							Reset
						</button>
					</div>
				</div>
			</div>
		</div>

		<div class="modal" id="alreadyScoredWarning" data-backdrop="static" data-keyboard="false">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5>Warning!</h5>
					</div>
					<div class="modal-body text-center">
						<span class="text-md" v-if="response">
							You have already scored response
							<strong>{{ response.ref_id }}</strong>
						</span>
					</div>
					<div class="modal-footer">
						<button class="btn btn-flat" data-dismiss="modal">Cancel</button>
						<button @click="scoreResponse()" class="btn btn-flat theme" data-dismiss="modal">Score</button>
					</div>
				</div>
			</div>
		</div>

		<!-- <mzfooter></mzfooter> -->
	</div>
</template>


<script>
//Libraries
import _ from "lodash";
import Vue from "vue";
import BB from "bluebird";
import Notie from "@/services/NotieService";
import $ from "jquery";
import moment from "moment";

//Services
import AuthService from "@/services/AuthService";
import ScoringService from "@/services/ScoringService";
import MessageService from "@/services/MessageService";
import ItemService from "@/services/ItemService";
import Utils from "@/services/Utils";
import TimeoutService from "@/services/TimeoutService";
import ResourceService from "@/services/ResourceService";
import ActivityService from "@/services/ActivityService";
import fs from "@/services/FormatService";
import store from "@/services/Store";

//Components
import Rubric from "@/components/Rubric";
import Score from "@/components/Score";
import MultiScore from "@/components/MultiScore";
import Media from "@/components/viewer/Media";
import Resource from "@/components/viewer/Resource";
import ExemplarList from "@/components/ExemplarList";
import ConfigSelect from "@/components/ConfigSelect";
import ViewerControls from "@/components/viewer/ViewerControls";
import RichText from "@/components/RichText";
import PersonalNote from "@/components/PersonalNote";
import ConfigUserSearch from "@/components/ConfigUserSearch";

//Scoring drivers
import FirstScoreDriver from "@/services/ScoringDrivers/FirstScoreDriver";
import SecondScoreDriver from "@/services/ScoringDrivers/SecondScoreDriver";
import ResolutionDriver from "@/services/ScoringDrivers/ResolutionDriver";
import SingleScoreDriver from "@/services/ScoringDrivers/SingleScoreDriver";
import ViewingDriver from "@/services/ScoringDrivers/ViewingDriver";
import ViewAllDriver from "@/services/ScoringDrivers/ViewAllDriver";
import AuditDriver from "@/services/ScoringDrivers/AuditDriver";

export default {
	name: "Viewer",
	data() {
		var should_return = false;
		if (this.$route.query.return) {
			should_return = true;
		}
		var should_keep = false;
		if (this.$route.query.keep) {
			should_keep = true;
		}
		if (this.$route.query.skipqc) {
			this.$route.params.skipqc = true;
		}

		return {
			fs: fs,
			should_return: should_return,
			should_keep: should_keep,
			params: this.$route.params,
			scoringRecord: {},

			loading: true,
			submitting: false,
			releasing: false,
			flagging: false,
			refreshNav: null,

			qc_type: 0,
			score_count: 0,
			reset: "",
			section: null,
			item: null,

			//Response rendering
			response0: null,
			response1: null,
			responseReady: [false, false],
			view: 0,
			buffer: 1,
			next_response: null,
			student: null,

			// showRubric: store.getDefault(this, "viewer.showRubric", true),
			// showResources: store.getDefault(
			// 	this,
			// 	"viewer.showResources",
			// 	false
			// ),
			showRubric: true,
			showResources: false,
			showNotes: false,
			splitRatio: store.getDefault(this, "viewer.splitRatio", 0.5),
			notesSplitRatio: store.getDefault(this, "viewer.notesSplitRatio", 0.2),
			showEscalateUI: false,
			pickedResource: null,
			pickedExemplar: null,
			toggle_hit: false,
			resizing: false,

			score: null,
			initScore: null,
			resFirstScore: null,
			resSecondScore: null,
			rubricComplete: false,

			chan: new Vue(),

			user: this.$route.meta.user,
			mode: this.$route.params.mode,

			driver: null,

			flags: [],
			flagAlert: null,
			flagReason: "",
			showFlagUI: false,
			updatingAuditFlag: -1,

			flagReviewed: false,

			messageToUsers: null,
			messageText: "",
			messageSubject: "",
			messageImportant: false,

			messages: [],

			escalationFeedback: "",
			escalationDestinations: [],
			escalateTraining: false,
			escalateValidity: false,
			escalateQual: false,
			escalateCalibration: false,
			escalateRangefinding: false,
			escalationScore: null,
			showEscalateUI: false,

			resetting_score: null,

			caching: false,
			cachedResponse: null,
			previousCached: false,

			timeoutTimer: null,
			timeout: 1000,

			qcTrueFeedback: "",
			showValFeedback: false,
			showValEndMsg: false,
			showCalEndMsg: false,
			showComment: false,
			initComment: null,
			comment: null,
			commentReset: null,
			existingCommentID: null,

			initFeedback: null,
			feedback: null,
			feedbackReset: null,

			qualMsgRead: false,
			showQualStartMsg: false,
			showQualEndMsg: false,
			scrollEnd: false,

			nav: null,
			delivery: null,

			addingScoringNote: false,
			scoringNote: "",
			scoringNoteInit: "",
			scoringNoteTooltip: `Add scoring consideration<br /><span class="text-left text-muted text-xxs">A note will be attached to this piece of student work, and will be visible to all scorers.</span>`,

			showExemplarUI: false,
			pickedExemplaryTraits: [],
			escalateExemplarTooltip: `Escalate<br /><span class="text-left text-muted text-xxs">This response will be marked for consideration for use as an exemplar.</span>`,
		};
	},
	components: {
		Rubric,
		Media,
		Resource,
		ExemplarList,
		Score,
		MultiScore,
		ViewerControls,
		RichText,
		ConfigSelect,
		ConfigUserSearch,
		PersonalNote,
	},
	created() {
		this.timeoutTimer = setInterval(() => {
			let timeout = Math.floor(TimeoutService.getTimeout() / 1000);
			this.$set(this, "timeout", timeout);
		}, 1000);
		console.log("mod ", this.mode);
		switch (this.mode) {
			case "FIRST":
				this.driver = FirstScoreDriver;
				break;
			case "SECOND":
				this.driver = SecondScoreDriver;
				break;
			case "RESOLUTION":
				this.driver = ResolutionDriver;
				break;
			case "VIEWING":
				this.driver = ViewingDriver;
				break;
			case "VIEW ALL":
				this.driver = ViewAllDriver;
				break;
			case "SINGLE":
				this.driver = SingleScoreDriver;
				break;
			case "BACKREAD":
				this.driver = BackreadDriver;
				break;
			case "QUEUE BACKREAD":
				this.driver = QueueBackreadDriver;
				break;
			case "AUDITING":
				this.driver = AuditDriver;
				break;
			case "FLAG QUEUE":
				this.driver = FlagQueueDriver;
				break;
			case "QC_TRUE_SCORE":
				this.driver = QCTrueScoreDriver;
				break;
			case "TRAINING":
				this.driver = TrainingDriver;
				break;
			case "RANGEFINDING":
				this.driver = RFDriver;
				break;
			default:
				break;
		}

		this.resetView();
		if (this.driver.multiItem) {
			this.getNext(true);
		} else {
			this.loadItem(this.params.assessment_id).then(() => {
				this.getNext(true);
			});
		}

		document.addEventListener("mouseup", this.resourceResizeEnd);
		document.addEventListener("touchend", this.resourceResizeEnd);
		document.addEventListener("mouseup", this.notesResizeEnd);
		document.addEventListener("touchend", this.notesResizeEnd);
		document.addEventListener("mousemove", this.checkToggleHitbox);

		this.stopResize = _.debounce(() => {
			this.resizing = false;
		}, 250);
		this.startResize = () => {
			this.resizing = true;
			this.stopResize();
		};
		window.addEventListener("resize", this.startResize);
		window.addEventListener("resize", this.viewerScrollCheck);

		this.chan.$on("toggle-notes", this.toggleNotes);

		this.smock = this.$route.query.scorerMockup;
	},

	beforeDestroy() {
		document.removeEventListener("mouseup", this.resourceResizeEnd);
		document.removeEventListener("touchend", this.resourceResizeEnd);
		document.removeEventListener("mousemove", this.checkToggleHitbox);
		if (this.scoringRecord && this.scoringRecord.count > 0) {
			ActivityService.logScoringRecord(this.scoringRecord);
		}
		window.removeEventListener("resize", this.startResize);
		window.removeEventListener("resize", this.viewerScrollCheck);
	},

	computed: {
		showRes() {
			return true;

			return (
				this.driver.showScores(this.item) ||
				this.showEscalateUI ||
				this.driver.sidebarType() == "qc_true_score" ||
				this.showValFeedback ||
				this.showQualStartMsg ||
				this.showQualEndMsg ||
				this.showValEndMsg ||
				this.showCalEndMsg ||
				this.showComment
			);
		},
		showRubricComponent() {
			let sidebarType = this.driver.sidebarType();
			return (
				this.item &&
				(sidebarType == "normal" || sidebarType == "viewing") &&
				this.response &&
				!this.showValFeedback &&
				!this.showQualStartMsg &&
				!this.showQualEndMsg &&
				!this.showValEndMsg &&
				!this.showCalEndMsg
			);
		},
		exemplarTraits() {
			if (!this.item || !this.item.rubric || !this.item.rubric.traits || this.item.rubric.traits == 0) {
				return [];
			}

			let traits = [];
			_.each(this.item.rubric.traits, (trait) => {
				if (trait.separator) {
					return;
				}
				let spds = [];
				_.each(trait.score_point_descriptors, (spd) => {
					if (spd.exemplars && spd.exemplars.length > 0) {
						spds.push(spd);
					}
				});

				if (spds.length > 0) {
					traits.push({
						id: trait.id,
						name: trait.name,
						score_point_descriptors: spds,
					});
				}
			});

			return traits;
		},
		showScoreSubmit() {
			return this.showRubricComponent && this.driver.sidebarType() != "viewing";
		},
		splitPercent() {
			return this.splitRatio * 100;
		},
		sidenavWidth() {
			if (this.showRes) {
				return 460;
			} else {
				return 230;
			}
		},
		sidenavOffset() {
			if (this.showRubric) {
				return this.sidenavWidth;
			} else {
				return 0;
			}
		},
		sidenavRight() {
			if (this.showRubric) {
				return 0;
			} else {
				return this.sidenavWidth * -1;
			}
		},
		viewportRight() {
			if (this.showResources) {
				let offset = (1 - this.splitRatio) * (this.sidenavOffset + 25);
				return `calc(${this.splitPercent}vw + ${offset}px)`;
			} else {
				return this.sidenavOffset + 25 + "px";
			}
		},
		resourcesRight() {
			if (this.showResources) {
				return this.sidenavOffset + "px";
			} else {
				return `${this.splitPercent * -1}vw`;
			}
		},
		resourcesWidth() {
			if (this.showResources) {
				let offset = this.sidenavOffset * this.splitRatio;
				return `calc(${this.splitPercent}vw - ${offset}px)`;
			} else {
				return `calc(${this.splitPercent}vw - 1px)`;
			}
		},
		rubricCollapseRight() {
			return this.sidenavOffset - 1 + "px";
		},
		resourceCollapseRight() {
			if (this.showResources) {
				let offset = (1 - this.splitRatio) * this.sidenavOffset - 1;
				return `calc(${this.splitPercent}vw + ${offset}px)`;
			} else {
				return this.sidenavOffset - 1 + "px";
			}
		},
		resourceResizeRight() {
			if (this.showResources) {
				let offset = (1 - this.splitRatio) * this.sidenavOffset - 7;
				return `calc(${this.splitPercent}vw + ${offset}px)`;
			} else {
				return this.sidenavOffset - 7 + "px";
			}
		},
		notesSplitPercent() {
			return this.notesSplitRatio * 100;
		},
		notesBottom() {
			if (this.showNotes) {
				return `0`;
			} else {
				return `calc((100vh - 112px) * ${-1 * this.notesSplitRatio})`;
			}
		},
		notesHeight() {
			return `calc((100vh - 112px) * ${this.notesSplitRatio})`;
		},
		viewportBottom() {
			if (this.showNotes) {
				return this.notesHeight;
			} else {
				return `0`;
			}
		},
		notesResizeBottom() {
			if (this.showNotes) {
				return `calc(((100vh - 112px) * ${this.notesSplitRatio}) - 7px)`;
			} else {
				return `-7px`;
			}
		},
		notesResizeLeft() {
			if (this.showResources) {
				let offset = (1 - this.splitRatio) * this.sidenavOffset;
				return `calc(((100vw - (${this.splitPercent}vw + ${offset}px)) * 0.5) - 14px)`;
			} else {
				return `calc(((100vw - ${this.sidenavOffset}px) * 0.5) - 14px)`;
			}
		},
		response() {
			return this[this.viewResponse()];
		},
		alerts() {
			let alerts = [];
			if (this.item && this.item.alerts) {
				_.each(this.item.alerts, (alert) => {
					if (!alert.admin_only || this.user.role.admin_flags) {
						alerts.push({
							id: alert.id,
							label: alert.description || alert.code,
							requires_score: alert.requires_score,
						});
					}
				});
			}
			return alerts;
		},
		alertName() {
			if (this.params.alert_id) {
				let alert = _.find(this.alerts, { id: this.params.alert_id });
				if (alert) {
					return alert.label;
				}
			}

			return null;
		},
		alertsScorable() {
			let alerts = [];
			if (this.item && this.item.alerts) {
				_.each(this.item.alerts, (alert) => {
					if (!alert.admin_only || this.user.role.admin_flags) {
						alerts.push({
							id: alert.id,
							name: alert.description || alert.code,
							requires_score: alert.requires_score,
							disabled: alert.requires_score,
						});
					}
				});
			}
			return alerts;
		},
		canDoFlag() {
			let can = this.flagAlert && (!this.flagAlert.requires_score || this.rubricComplete);
			return can;
		},
		hasFlag() {
			return this.response && this.response.flags && this.response.flags.length > 0;
		},
		showEscalate() {
			return this.driver.canBeEscalated && this.user.role.can_escalate && !this.showFlagUI;
		},
		showRFEscalate() {
			return this.driver.canBeEscalated && this.user.role.page_rf_setup && !this.showFlagUI;
		},
		showExemplarEscalate() {
			return this.user.role.escalate_exemplars;
		},
		isWithheld() {
			return this.response && this.response.state == 20;
		},
		dirtyFlag() {
			let initId = this.response && this.response.flag_alert_id;
			let currentId = this.flagAlert && this.flagAlert.id;
			let initReason = this.response && this.response.flag_reason;
			return initId != currentId || initReason != this.flagReason;
		},
		canUnlockAndScore() {
			let complete = this.response && this.response.state == 10;
			let hasBackread = this.response && this.response.has_backread;
			return !(complete && hasBackread);
		},
		canReleaseAndScore() {
			let willBeComplete = this.response && this.response.release_state == 10;
			let hasBackread = this.response && this.response.has_backread;
			if (this.isWithheld) {
				return !(willBeComplete && hasBackread);
			} else {
				return false;
			}
		},

		messageToMultiple() {
			return this.messageToUsers && this.messageToUsers.length && this.messageToUsers.length > 1;
		},
		messageToAny() {
			return this.messageToUsers && this.messageToUsers.length && this.messageToUsers.length > 0;
		},
		messageScore() {
			if (!(this.messageToUsers && this.messageToUsers.length && this.messageToUsers.length == 1)) {
				return null;
			}
			let findUser = this.messageToUsers[0];
			let score = _.find(this.response.scores, { user_id: findUser.id });
			return score;
		},
		allowViewedAll() {
			if (!(this.item && this.item.require_view_all)) {
				return true;
			}
			return this.scrollEnd;
		},
		canComment() {
			return this.driver.canComment;
		},
		responseOwner() {
			if (!this.response) {
				return false;
			}
			if (!this.student) {
				return false;
			}

			let scored = _.find(this.response.scores, {
				user_id: this.user.id,
			});
			let firstScorer = scored && scored.score_type == 1;

			return firstScorer || this.response.state == 1;
		},
		studentFeedbacks() {
			if (!this.response) {
				return false;
			}

			let feedbacks = [];
			_.each(this.response.scores, (score) => {
				if (score.student_feedback) {
					feedbacks.push({
						id: score.id,
						text: score.student_feedback,
						score_type: score.score_type,
					});
				}
			});

			return feedbacks;
		},
	},

	methods: {
		doReturn() {
			this.$router.go(-1);
		},

		getNext(doScrollHook) {
			this.loading = true;

			return this.driver
				.getNext(this.params)
				.then((resp) => {
					if (this.driver.multiItem) {
						this.loadItem(resp.data.response.item_id).then((itemResp) => {
							this.gotResponse(resp.data);
							if (doScrollHook) {
								this.$nextTick(this.viewerScrollHook);
							}
						});
					} else {
						this.gotResponse(resp.data);
						if (doScrollHook) {
							this.$nextTick(this.viewerScrollHook);
						}
					}
				})
				.catch((err) => {
					if (this.driver.onError) {
						this.driver.onError(err, this.params, this);
						return;
					}

					if (err.response.status == 404 || err.response.status == 403 || err.response.status == 412) {
						Notie.info(err.response.data.message);
						this.doReturn();
					} else {
						Notie.error(err);
					}
				});
		},

		loadItem(assessment_id) {
			return BB.props({
				itemResp: ItemService.getItemWithExemplars(assessment_id),
			}).then((results) => {
				this.item = results.itemResp.data;
				this.item.assessment_id = assessment_id;
				this.item.rubric.reset = new Date().toString();
				if (this.item.resources && this.item.resources.length > 0) {
					this.pickedResource = this.item.resources[0];
				} else {
					this.showResources = false;
				}
			});
		},

		gotResponse(data) {
			var response = data.response;
			this.next_response = data.next_response;
			this.nav = data.nav;
			this.delivery = data.delivery;
			this.student = data.student;

			if (this[this.bufferResponse()] && this[this.bufferResponse()].id == response.id) {
				this.switchBuffer();
			} else {
				this.responseReady[this.view] = false;
				this[this.viewResponse()] = response;
			}
			this.flags = _.cloneDeep(response.flags);
			this.qc_type = data.type;
			this.score_count = data.score_count;
			this.messages = _.sortBy(data.messages, "created_at");
			MessageService.viewResponseMessages(response.id).then(() => {
				this.refreshNav = new Date();
			});
			this.showEscalateUI = false;
			this.loading = false;

			if (response.flag_alert_id != "") {
				this.flagAlert = _.find(this.alerts, {
					id: response.flag_alert_id,
				});
				this.flagReason = response.flag_reason;
			}

			//QC true score special case
			if (response.feedback) {
				this.qcTrueFeedback = _.clone(response.feedback);
			}

			if (response.qc_type == 2 && !this.qualMsgRead && this.mode != "QC_TRUE_SCORE") {
				//Show qual starting message
				this.showQualStartMsg = true;
				this.qualMsgRead = true;
			}

			this.initScore = null;
			if (this.driver.allowUpdateScore) {
				_.each(response.qc_scores, (qcs) => {
					if (qcs.user_id == this.user.id) {
						this.initScore = qcs;
					}
				});

				if (this.driver.canComment && this.initScore) {
					let comment = _.find(this.response.comments, {
						score_id: this.initScore.id,
					});
					if (comment) {
						this.showComment = true;
						this.initComment = comment.text;
						this.existingCommentID = comment.id;
					}
				}
			} else {
				//Preload agreement for resolution
				this.resFirstScore = _.find(response.scores, { score_type: 1 });
				this.resSecondScore = _.find(response.scores, {
					score_type: 2,
				});
			}

			this.reset = Utils.generateUUID();

			this.scrollEnd = false;
		},

		setupFinished(responseIndex) {
			this.responseReady[responseIndex] = true;
			this.$nextTick(this.viewerScrollCheck);
			if (responseIndex == this.view) {
				this.prefetchNext();
			}
		},

		submit() {
			// console.log("Submitting -- ",this.score)
			// for (let i = 0; i < this.score.trait_scores.length; i++) {
			// 	this.score.trait_scores[i].score = parseInt(this.score.trait_scores[i].score)

			// }
			if (this.submitting) {
				return;
			}

			if (this.qc_type != 0 && this.mode != "QC_TRUE_SCORE") {
				this.submitQC();
				return;
			}

			if (this.feedback != "") {
				this.score.student_feedback = this.feedback;
			}

			let scorePromise = this.driver.submitScore(
				this.score,
				this.response,
				this.should_return && this.should_keep
			);

			let commentPromise;
			if (this.comment != "") {
				let message = {
					text: this.comment,
				};
				commentPromise = MessageService.addMessage(this.response.id, message);
			}

			this.submitting = true;
			this.score.user_id = this.user.id;
			BB.props({
				score: scorePromise,
				comment: commentPromise,
			})
				.then((resps) => {
					this.scoringRecord.count++;
					this.resetView();
					Notie.success("Score saved!");
					if (this.should_return) {
						this.doReturn();
					} else {
						this.getNext();
					}
				})
				.catch((err) => {
					console.log(err);
					Notie.error("Failed to submit score!", err);
				})
				.finally(() => {
					this.submitting = false;
				});
		},

		addComment() {
			let message = {
				text: this.comment,
			};
			return MessageService.addMessage(this.response.id, message)
				.then((resp) => {
					Notie.info("Comment added");
					this.comment = "";
					this.commentReset = new Date();
					this.getNext();
				})
				.catch((err) => {
					Notie.error("Failed to add comment", err);
				});
		},

		maybeSubmitThenNav(responseID) {
			if (!this.rubricComplete) {
				this.resetView();
				this.navToResponse(responseID);
				return;
			}

			this.submitting = true;
			this.score.user_id = this.user.id;

			//Putting the current ID on the score to submit causes it to update instead creating a new score
			if (this.initScore && this.initScore.id) {
				this.score.id = this.initScore.id;
			}

			var comment;
			if (this.driver.canComment) {
				comment = {
					text: this.comment,
					id: this.existingCommentID,
				};
			}

			QCService.submitScore(this.score, this.response, comment)
				.then((resp) => {
					this.resetView();
					Notie.success("Score updated!");
					if (this.should_return) {
						this.doReturn();
					} else {
						this.navToResponse(responseID);
					}
				})
				.catch((err) => {
					console.log(err);
					Notie.error("Failed to update score!", err);
				})
				.finally(() => {
					this.submitting = false;
				});
		},

		navToResponse(responseID) {
			this.loading = true;

			this.driver
				.getResponse(this.params, responseID)
				.then((resp) => {
					this.gotResponse(resp.data);
				})
				.catch((err) => {
					if (this.driver.onError) {
						this.driver.onError(err, this.params, this);
						return;
					}

					if (err.response.status == 404 || err.response.status == 403 || err.response.status == 412) {
						Notie.info(err.response.data.message);
						this.doReturn();
					} else {
						Notie.error(err);
					}
				});
		},

		qcContinue() {
			this.resetView();
			this.getNext();
		},

		submitQC() {
			this.submitting = true;
			this.score.user_id = this.user.id;

			var comment;
			if (this.driver.canComment) {
				comment = {
					text: this.comment,
					id: this.existingCommentID,
				};
			}

			//TODO Handle showing feedback
			QCService.submitScore(this.score, this.response, comment)
				.then((resp) => {
					if (this.qc_type == 4) {
						if (resp.data.was_deactivated) {
							this.showCalEndMsg = true;
							return;
						}
					}
					if (this.qc_type == 3) {
						if (resp.data.was_deactivated) {
							this.showValEndMsg = true;
							return;
						}

						this.valCorrect = resp.data.was_correct;
						if (
							(resp.data.was_correct && resp.data.show_positive) ||
							(!resp.data.was_correct && resp.data.show_negative)
						) {
							//Show positive deal
							this.showValFeedback = true;
							return;
						}
					}
					if (this.qc_type == 2) {
						if (resp.data.was_set_complete) {
							this.qualPassed = !resp.data.was_deactivated;
							this.showQualEndMsg = true;
							return;
						}
					}
					this.resetView();
					Notie.success("Score saved!");
					if (this.should_return) {
						this.doReturn();
					} else {
						this.getNext();
					}
				})
				.catch((err) => {
					console.log(err);
					Notie.error("Failed to submit score!", err);
				})
				.finally(() => {
					this.submitting = false;
				});
		},

		flagQueueAdvance() {
			if (this.submitting) {
				return;
			}
			this.submitting = true;
			this.driver
				.advance(this.response)
				.then((resp) => {
					this.scoringRecord.count++;
					this.resetView();
					if (this.should_return) {
						this.doReturn();
					} else {
						this.getNext();
					}
				})
				.catch((err) => {
					console.log(err);
					Notie.error("Failed to advance flag queue!", err);
				})
				.finally(() => {
					this.submitting = false;
				});
		},

		resetView() {
			let viewport = document.getElementById("media");
			if (viewport) {
				viewport.scrollTop = 0;
			}
			this.loading = true;
			this[this.viewResponse()] = null;
			this.showValFeedback = false;
			this.showQualStartMsg = false;
			this.showQualEndMsg = false;
			this.showComment = false;
			this.initComment = "";
			this.comment = "";
			this.existingCommentID = null;
			this.reset = Utils.generateUUID();
		},

		toggleRubric() {
			this.showRubric = !this.showRubric;
			// store.set(this, "viewer.showRubric", this.showRubric);
		},

		toggleResource() {
			if (this.showRubric && this.showResources) {
				//If they are both open, just close the resources
				this.showResources = false;
			} else if (!this.showRubric && !this.showResources) {
				//If they are both closed just open the resources
				this.showResources = true;
			} else {
				//Otherwise toggle both
				this.showRubric = !this.showRubric;
				this.showResources = !this.showResources;
			}
			if (this.showResources) {
				$(".tabs-overlay").addClass("show");
			} else {
				$(".toggles-overlay").removeClass("show");
			}
			// store.set(this, "viewer.showResources", this.showResources);
			// store.set(this, "viewer.showRubric", this.showRubric);
		},

		openFlagModal() {},

		escalate() {
			this.escalationFeedback = "";
			this.escalationDestinations = [];
			this.escalateTraining = false;
			this.escalateValidity = false;
			this.escalateQual = false;
			this.escalateCalibration = false;
			this.escalationScore = _.clone(this.score);
			this.showEscalateUI = true;
		},

		flag() {
			this.flagAlert = null;
			this.flagReason = "";
			this.showFlagUI = true;
		},

		updateEscalationSelections() {
			this.escalationDestinations = [];
			if (this.escalateTraining) {
				this.escalationDestinations.push(1);
			}
			if (this.escalateQual) {
				this.escalationDestinations.push(2);
			}
			if (this.escalateValidity) {
				this.escalationDestinations.push(3);
			}
			if (this.escalateCalibration) {
				this.escalationDestinations.push(4);
			}
		},

		sendEscalation() {
			var body = {
				response_id: this.response.id,
				destinations: this.escalationDestinations,
			};
			//Don't include feedback and score with rangefinding
			if (!this.escalationDestinations.includes(5)) {
				body.score = this.escalationScore;
				body.feedback = this.escalationFeedback;
			}

			ScoringService.escalate(body)
				.then(() => {
					Notie.success("Response escalated!");
					this.showEscalateUI = false;
				})
				.catch((e) => {
					console.log(e);
					Notie.error("Failed to escalate!");
					this.showEscalateUI = false;
				});
		},

		sendRFEscalation() {
			var body = {
				response_id: this.response.id,
				destinations: [5],
			};

			ScoringService.escalate(body)
				.then(() => {
					Notie.success("Response added to rangefinding!");
					this.showEscalateUI = false;
				})
				.catch((e) => {
					console.log(e);
					Notie.error("Failed to add to rangefinding!");
					this.showEscalateUI = false;
				});
		},

		openExemplarUI() {
			this.showExemplarUI = true;
		},

		escalateExemplar() {
			let body = {
				score: this.score,
				response_id: this.response.id,
				exemplary_traits: this.pickedExemplaryTraits,
			};
			ScoringService.escalateExemplar(body)
				.then(() => {
					Notie.success("Response marked as possible exemplar");
					this.showExemplarUI = false;
				})
				.catch((e) => {
					console.log(e);
					Notie.error("Failed to add to exemplar pool!");
					this.showExemplarUI = false;
				});
		},

		submitFlag() {
			if (this.flagging) {
				return;
			}
			if (this.response.qc_type) {
				Notie.info("This response cannot be flagged");
				return;
			}

			var body = {
				reason: this.flagReason,
				alert_id: this.flagAlert.id,
				response_id: this.response.id,
			};

			if (this.flagAlert.requires_score && this.score) {
				this.score.response_id = this.response.id;
				body.score = this.score;
			}

			this.$set(this, "flagging", true);
			ScoringService.flagResponse(body)
				.then((resp) => {
					this.scoringRecord.count++;
					this.flagAlert = null;
					this.flagReason = "";
					this.showFlagUI = false;
					this.resetView();
					Notie.success("Response flagged!");
					if (this.should_return) {
						this.doReturn();
					} else {
						this.getNext();
					}
				})
				.catch(function (err) {
					console.log(err);
					Notie.error("Failed to flag response!", err);
				})
				.finally(() => {
					this.$set(this, "flagging", false);
				});
		},

		prefetchNext() {
			if (!this.should_return) {
				console.log("Prefetching next response");
				this.caching = true;
				this.responseReady[this.buffer] = false;
				this[this.bufferResponse()] = this.next_response;
				this.caching = false;
			}
		},

		switchBuffer() {
			this.view = (this.view + 1) % 2;
			this.buffer = (this.buffer + 1) % 2;
			if (this.responseReady[this.view]) {
				this.prefetchNext();
			}
		},

		viewResponse() {
			return `response${this.view}`;
		},

		bufferResponse() {
			return `response${this.buffer}`;
		},

		//Auditing Stuff
		canScore() {
			return ScoringService.canScore(this.response);
		},

		auditScore() {
			var scr = _.find(this.response.scores, { user_id: this.user.id });
			if (scr) {
				this.showAlreadyScoredModal();
				return;
			}
			this.scoreResponse();
		},

		scoreResponse() {
			if (this.response.locked) {
				let keepLock = false;
				//Check if we're in a queue that wants to keep responses until some condition (flag queue scoring)
				if (this.driver.canAdvance) {
					keepLock = !this.driver.canAdvance(this.flags, this.params);
				}
				ScoringService.unlockResponse(this.response)
					.then(() => {
						ScoringService.auditScore(this.response, this.$router, keepLock);
					})
					.catch((e) => {
						Notie.error("Failed to unlock response");
						this.getNext();
					});
			} else {
				ScoringService.auditScore(this.response, this.$router);
			}
		},

		showAlreadyScoredModal() {
			$("#alreadyScoredWarning").modal("show");
		},

		unlock() {
			ScoringService.unlockResponse(this.response)
				.then(() => {
					Notie.info("Response unlocked");
					this.getNext();
				})
				.catch((e) => {
					Notie.error("Failed to unlock response");
					this.getNext();
				});
		},

		resetScorePrompt(score) {
			this.resetting_score = score;
			$("#resetConfirm").modal("show");
		},

		resetScore(score) {
			ScoringService.resetScore(this.response.id, score.id)
				.then(() => {
					Notie.success("Score reset");
					this.resetView();
					this.getNext();
				})
				.catch((e) => {
					console.log(e);
					Notie.error("Failed to reset score");
				});
		},

		timeoutColor(timeout) {
			let warning_time = 120;
			let danger_time = 60;
			return {
				"text-danger": timeout < danger_time,
				"text-warning": timeout < warning_time && timeout >= danger_time,
			};
		},

		pickResource(res) {
			this.pickedExemplar = null;
			this.pickedResource = res;
		},

		pickExemplar(trait, spd) {
			this.pickedResource = null;
			spd.trait_id = trait.id;
			this.pickedExemplar = spd;
		},

		pickExemplarFromRubric(e) {
			if (!this.item || !this.item.rubric || !this.item.rubric.traits) {
				return false;
			}

			_.each(this.item.rubric.traits, (trait) => {
				if (e.trait.id == trait.id) {
					_.each(trait.score_point_descriptors, (spd) => {
						if (e.sp.val == spd.val) {
							this.pickExemplar(trait, spd);
						}
					});
				}
			});
			if (!this.showResources) {
				this.toggleResource();
				this.toggleRubric();
			}
		},

		syncExemplaryTraits(e) {
			console.log("sync", e);
			this.pickedExemplaryTraits = e;
		},

		openExemplar(exemplar) {
			if (exemplar.external_url) {
				var windowRef = window.open();
				windowRef.location = exemplar.external_url;
			} else if (exemplar.response) {
				let rid = this.item.rubric.id;
				let tid = this.pickedExemplar.trait_id;
				let sco = this.pickedExemplar.val;
				let eid = exemplar.id;
				let routeData = this.$router.resolve({
					path: `/exemplar/${rid}/${tid}/${sco}/${eid}`,
				});
				window.open(routeData.href, "_blank");
			} else {
				notie.error("Failed to open exemplar!");
			}
		},

		viewResource(resource) {
			console.log("SENDIGN THIS ", this.params.assessment_id);
			if (resource.type == 1) {
				ResourceService.viewResource(this.params.assessment_id, resource);
			} else if (resource.type == 2) {
				ResourceService.viewExternalResource(resource.path);
			} else if (resource.type == 4) {
				ResourceService.viewExternalResource(resource.path);
			}
			if (this.showResources) {
				this.toggleResource();
			}
		},

		viewExemplar(spd) {
			_.each(spd.exemplars, (path) => {
				ResourceService.viewExternalResource(path);
			});
			if (this.showResources) {
				this.toggleResource();
			}
		},

		markFlagReviewed(flag) {
			let call = ScoringService.markReviewed;
			if (flag.reviewed) {
				call = ScoringService.markNotReviewed;
			}

			this.$set(flag, "reviewing", true);
			call(this.response.id, flag.id)
				.then((resp) => {
					flag.reviewed = !flag.reviewed;
				})
				.catch(function (err) {
					console.error(err);
					Notie.error("Failed to mark flag as reviewed!", err);
				})
				.finally(() => {
					this.$set(flag, "reviewing", false);
				});
		},

		auditFlag(flag) {
			this.updatingAuditFlag = flag.id;
			this.flagReason = flag.reason;
			this.flagAlert = _.find(this.alerts, { id: flag.alert_id });
		},

		cancelAuditFlag() {
			this.flagAlert = null;
			this.flagReason = "";
			this.updatingAuditFlag = null;
		},

		updateAuditFlag(flag) {
			if (flag.updating) {
				return;
			}

			let newFlag = {
				id: flag.id,
				reason: this.flagReason,
				alert_id: this.flagAlert && this.flagAlert.id,
			};

			this.$set(flag, "updating", true);
			ScoringService.updateFlag(this.response.id, newFlag)
				.then((resp) => {
					let i = _.findIndex(this.flags, { id: resp.data.id });
					if (i != -1) {
						this.flags.splice(i, 1, resp.data);
					}

					this.flagAlert = null;
					this.flagReason = "";
					this.updatingAuditFlag = null;
					this.$forceUpdate();
				})
				.catch(function (err) {
					console.error(err);
					Notie.error("Failed to flag response!", err);
				})
				.finally(() => {
					this.$set(flag, "updating", false);
				});
		},

		deleteFlag(flag) {
			this.$set(flag, "deleting", true);
			ScoringService.deleteFlag(this.response.id, flag.id)
				.then((resp) => {
					_.remove(this.flags, { id: flag.id });
					this.$forceUpdate();
				})
				.catch((err) => {
					console.error(err);
					Notie.error("Failed to delete flag!", err);
				})
				.finally(() => {
					this.$set(flag, "deleting", false);
				});
		},

		releaseFlag() {
			if (this.releasing) {
				return;
			}

			this.$set(this, "releasing", true);
			ScoringService.releaseFromFlagged(this.response.id)
				.then((resp) => {
					this.getNext();
				})
				.catch((err) => {
					console.error(err);
					Notie.error("Failed to release flag!", err);
				})
				.finally(() => {
					this.$set(this, "releasing", false);
				});
		},

		releaseFlagAndScore() {
			if (this.releasing) {
				return;
			}

			this.$set(this, "releasing", true);
			ScoringService.releaseFromFlagged(this.response.id)
				.then((resp) => {
					let keepLock = false;
					//Check if we're in a queue that wants to keep responses until some condition (flag queue scoring)
					if (this.driver.canAdvance) {
						keepLock = !this.driver.canAdvance(this.flags, this.params);
					}
					ScoringService.auditScore(resp.data, this.$router, keepLock);
				})
				.catch((err) => {
					console.error(err);
					Notie.error("Failed to release flag!", err);
				})
				.finally(() => {
					this.$set(this, "releasing", false);
				});
		},

		resourceResizeCalculate(event) {
			let x = event.pageX;
			if (event.touches && event.touches[0]) {
				x = event.touches[0].clientX;
			}
			let viewportWidth = window.innerWidth - this.sidenavOffset;
			let splitRatio = x / viewportWidth;
			if (splitRatio < 0.25) {
				splitRatio = 0.25;
			}
			if (splitRatio > 0.75) {
				splitRatio = 0.75;
			}
			this.splitRatio = 1 - splitRatio;
		},

		resourceResizeStart(event) {
			document.addEventListener("mousemove", this.resourceResizeCalculate);
			document.addEventListener("touchmove", this.resourceResizeCalculate);
			this.resizing = true;
		},

		resourceResizeEnd() {
			document.removeEventListener("mousemove", this.resourceResizeCalculate);
			document.removeEventListener("touchmove", this.resourceResizeCalculate);
			this.resizing = false;
			store.set(this, "viewer.splitRatio", this.splitRatio);
		},

		notesResizeCalculate(event) {
			let y = event.pageY;
			if (event.touches && event.touches[0]) {
				x = event.touches[0].clientY;
			}
			let viewportHeight = window.innerHeight - 112;
			let splitRatio = (y - 112) / viewportHeight;
			if (splitRatio < 0.1) {
				splitRatio = 0.1;
			}
			if (splitRatio > 0.9) {
				splitRatio = 0.9;
			}
			this.notesSplitRatio = 1 - splitRatio;
			store.set(this, "viewer.notesSplitRatio", this.notesSplitRatio);
		},

		notesResizeStart(event) {
			document.addEventListener("mousemove", this.notesResizeCalculate);
			document.addEventListener("touchmove", this.notesResizeCalculate);
			this.resizing = true;
		},

		notesResizeEnd() {
			document.removeEventListener("mousemove", this.notesResizeCalculate);
			document.removeEventListener("touchmove", this.notesResizeCalculate);
			this.resizing = false;
			store.set(this, "viewer.splitRatio", this.splitRatio);
		},

		checkToggleHitbox(event) {
			let x = event.pageX;
			let y = event.pageY;
			if (event.touches && event.touches[0]) {
				x = event.touches[0].clientX;
				y = event.touches[0].clientY;
			}

			let sidenavAndResources = this.sidenavOffset;
			let notes = 0;
			if (this.showResources) {
				let viewportWidth = window.innerWidth - this.sidenavOffset;
				sidenavAndResources += viewportWidth * this.splitRatio;
			}
			if (this.showNotes) {
				let viewportHeight = window.innerHeight - 112;
				notes += viewportHeight * this.notesSplitRatio;
			}

			let xThreshold = window.innerWidth - (sidenavAndResources + 50);
			let yThreshold = window.innerHeight - (notes + 50);

			if (x > xThreshold || y > yThreshold) {
				this.toggle_hit = true;
			} else {
				this.toggle_hit = false;
			}
		},

		viewerScrollHook() {
			let viewer = document.getElementById("media");
			if (!viewer) {
				debugger;
			}
			viewer.addEventListener("scroll", this.viewerScrollCheck);
			//Need to do one initial check in case the div isn't scrollable to begin with
			this.viewerScrollCheck();
		},

		viewerScrollCheck() {
			let viewer = document.getElementById("media");
			console.log(viewer.scrollHeight, viewer.scrollTop, viewer.clientHeight);
			if (viewer.scrollHeight - (viewer.scrollTop + viewer.clientHeight) < 55) {
				console.log("Scroll changed with viewerscrollcheck");
				this.scrollEnd = true;
			}
		},

		toggleNotes() {
			this.showNotes = !this.showNotes;
		},

		editScoringNote() {
			this.addingScoringNote = true;
			this.scoringNote = "";
			this.scoringNoteInit = "";
		},

		addScoringNote() {
			ScoringService.addScoringNote(this.response.id, this.scoringNote)
				.then((resp) => {
					Notie.success("Scoring consideration added");
					this.response.scoring_note = this.scoringNote;
					this.addingScoringNote = false;
				})
				.catch((err) => {
					console.log(err);
					Notie.error("Failed to apply scoring consideration", err);
				});
		},

		removeScoringNote() {
			ScoringService.removeScoringNote(this.response.id)
				.then((resp) => {
					Notie.success("Scoring consideration removed");
					this.response.scoring_note = "";
				})
				.catch((err) => {
					console.log(err);
					Notie.error("Failed to remove scoring consideration", err);
				});
		},

		print(response) {
			_.each(this.response.media, (m, i) => {
				let windowRef = window.open();
				if (m.mime_type == "text") {
					windowRef.location = `/v1/print/response/${response.id}/${i}`;
				} else {
					windowRef.location = m.signed_url;
				}
			});
		},

		scoreTypeString(message) {
			switch (message.score_type) {
				case 1:
					return "First";
				case 2:
					return "Second";
				case 3:
					return "Resolution";
				default:
					return "Comment";
			}
		},

		scoreTypeIcon(message) {
			switch (message.score_type) {
				case 1:
					return "fa-check";
				case 2:
					return "fa-check-double";
				case 3:
					return "fa-shield-check";
				default:
					return "fa-comment";
			}
		},
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
img {
	max-width: 100%;
	max-height: 100%;
	display: block; /* remove extra space below image */
}
.rubric-col {
	background-color: white;
	width: 230px;
}

.viewer-container {
	border-top: 1px solid #d9d9d9;
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	background-color: #f5f5f5;
}

/* Default state, viewer is full width, rubric and resources are right:(their width) */

.viewer-viewport {
	position: absolute;
	display: inline;
	overflow: auto;
	left: 0;
	top: 0;
	/* background-color: #f5f5f5; */
}

.resources {
	position: absolute;
	height: 100%;
	bottom: 0;
	top: 0;
	width: calc(50vw);
	background-color: #eeeeee;
	border-left: 1px solid #d9d9d9;
	box-shadow: inset 6px 0px 10px -4px rgba(184, 182, 184, 1);
}

.resources > .resources-container {
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	overflow: auto;
}

.viewer-sidenav {
	position: absolute;
	width: 230px;
	height: 100%;
	bottom: 0;
	right: -230px;
	top: 0;
	padding-left: 10px;
	padding-right: 10px;
	padding-top: 5px;

	overflow: auto;
	border-left: 1px solid #d9d9d9;
	background-color: #eeeeee;
}

.side-btn {
	height: 25px;
	width: 25px;
	background-color: #eeeeee;
	border-left: 1px solid #d9d9d9;
	border-top: 1px solid #d9d9d9;
	border-bottom: 1px solid #d9d9d9;
	-webkit-border-top-left-radius: 5px;
	-webkit-border-bottom-left-radius: 5px;
	-moz-border-radius-topleft: 5px;
	-moz-border-radius-bottomleft: 5px;
	border-top-left-radius: 5px;
	border-bottom-left-radius: 5px;
	position: absolute;
	cursor: pointer;
	z-index: 1000000000000000;
}

.bottom-btn {
	margin-bottom: -1px;
	margin-right: 25px;
	height: 25px;
	width: 25px;
	background-color: #eeeeee;
	border-left: 1px solid #d9d9d9;
	border-right: 1px solid #d9d9d9;
	border-top: 1px solid #d9d9d9;
	-webkit-border-top-left-radius: 5px;
	-webkit-border-top-right-radius: 5px;
	-moz-border-radius-topleft: 5px;
	-moz-border-radius-topright: 5px;
	border-top-left-radius: 5px;
	border-top-right-radius: 5px;
	position: absolute;
	cursor: pointer;
	z-index: 19;
}

.resize-btn {
	height: 28px;
	top: calc(50% - 14px);
	width: 12px;
	background-color: #eeeeee;
	border-left: 1px solid #d9d9d9;
	border-right: 1px solid #d9d9d9;
	border-top: 1px solid #d9d9d9;
	border-bottom: 1px solid #d9d9d9;
	-webkit-border-top-left-radius: 3px;
	-webkit-border-bottom-left-radius: 3px;
	-webkit-border-top-right-radius: 3px;
	-webkit-border-bottom-right-radius: 3px;
	-moz-border-radius-topleft: 3px;
	-moz-border-radius-bottomleft: 3px;
	-moz-border-radius-topright: 3px;
	-moz-border-radius-bottomright: 3px;
	border-top-left-radius: 3px;
	border-bottom-left-radius: 3px;
	border-top-right-radius: 3px;
	border-bottom-right-radius: 3px;
	position: absolute;
	cursor: grab;
	z-index: 1000000000000000;
	visibility: hidden;
}
.resize-btn > i {
	font-size: 16px;
	margin-left: -3px;
	line-height: 26px;
}
.show-resources > .resize-btn {
	visibility: visible;
}

.resize-btn-h {
	height: 12px;
	left: calc(50% - 14px);
	width: 28px;
	background-color: #eeeeee;
	border-left: 1px solid #d9d9d9;
	border-right: 1px solid #d9d9d9;
	border-top: 1px solid #d9d9d9;
	border-bottom: 1px solid #d9d9d9;
	-webkit-border-top-left-radius: 3px;
	-webkit-border-bottom-left-radius: 3px;
	-webkit-border-top-right-radius: 3px;
	-webkit-border-bottom-right-radius: 3px;
	-moz-border-radius-topleft: 3px;
	-moz-border-radius-bottomleft: 3px;
	-moz-border-radius-topright: 3px;
	-moz-border-radius-bottomright: 3px;
	border-top-left-radius: 3px;
	border-bottom-left-radius: 3px;
	border-top-right-radius: 3px;
	border-bottom-right-radius: 3px;
	position: absolute;
	cursor: grab;
	z-index: 1000000000000000;
	visibility: hidden;
}
.resize-btn-h > i {
	font-size: 16px;
	margin-left: 5px;
	margin-top: -3px;
	-webkit-transform: rotate(90deg);
	transform: rotate(90deg);
	position: absolute;
}
.show-notes > .resize-btn-h {
	visibility: visible;
}

.rubric-collapse-btn {
	right: 0;
	top: 10px;
}

.resource-collapse-btn {
	right: 0;
	top: 45px;
}

.toggles-hitbox {
	position: absolute;
	right: 0;
	top: 0;
	width: 45px;
	height: 100%;
	opacity: 0;
	/* This was breaking the scrollbar */
	/* z-index: 1000000000000001; */
	z-index: -1;
}

.notes-container {
	position: absolute;
	height: 100%;
	left: 0;
	height: 200px;
	max-height: calc(100vh - 112px);

	border-top: 1px solid #d9d9d9;
	background-color: #eeeeee;
	box-shadow: inset 0px -6px 10px -4px rgba(184, 182, 184, 1);
}

/* When rubric is showing */

/* .show-sidenav > .viewer-sidenav {
	right: 0;
}
.show-sidenav.show-res > .viewer-sidenav {
	width: 460px;
}
.viewer-sidenav.show-res {
	bottom: 0;
	right: -460px;
} */

.trans {
	-webkit-transition: all 200ms cubic-bezier(0.25, 0.1, 0.25, 1), opacity 500ms cubic-bezier(0.25, 0.1, 0.25, 1);
	-moz-transition: all 200ms cubic-bezier(0.25, 0.1, 0.25, 1), opacity 500ms cubic-bezier(0.25, 0.1, 0.25, 1);
	-o-transition: all 200ms cubic-bezier(0.25, 0.1, 0.25, 1), opacity 500ms cubic-bezier(0.25, 0.1, 0.25, 1);
	transition: all 200ms cubic-bezier(0.25, 0.1, 0.25, 1), opacity 500ms cubic-bezier(0.25, 0.1, 0.25, 1);

	-webkit-transition-timing-function: cubic-bezier(0.25, 0.1, 0.25, 1);
	-moz-transition-timing-function: cubic-bezier(0.25, 0.1, 0.25, 1);
	-o-transition-timing-function: cubic-bezier(0.25, 0.1, 0.25, 1);
	transition-timing-function: cubic-bezier(0.25, 0.1, 0.25, 1);
}

.viewer-viewport::-webkit-scrollbar,
.resources-container::-webkit-scrollbar {
	width: 13px;
	height: 13px;
}
.viewer-viewport::-webkit-scrollbar-thumb,
.resources-container::-webkit-scrollbar-thumb {
	border-radius: 10px;
}

.viewer-viewport > .essay,
.resources > .essay {
	margin-left: auto;
	margin-right: auto;
	/*margin-bottom: 70px;*/

	border: none;
}

.top-box {
	width: 800px;
	margin-top: 1rem;
	margin-left: auto;
	margin-right: auto;
	padding: 0.5rem 1rem;
	border-width: 2px;
}

.notes-list {
	margin-bottom: 0;
	padding-left: 1.5rem;
}

/* .prevScores {
	overflow: scroll;
	margin-top: 20px;
	position: relative;
	margin-left: auto;
	margin-right: auto;
	max-width: 800px;
	width: 80%;

	padding: 10px;
	-webkit-box-shadow: 3px 3px 11px 1px rgba(184, 182, 184, 1);
	-moz-box-shadow: 3px 3px 11px 1px rgba(184, 182, 184, 1);
	box-shadow: 3px 3px 11px 1px rgba(184, 182, 184, 1);
	background-color: white;
} */
.prevScores {
	/* position: absolute;
	top: 10px;
	left: 10px; */
}

/*background-color: #78909c;*/
/* } */

::-webkit-scrollbar {
	width: 7px;
}
::-webkit-scrollbar-thumb {
	border-radius: 4px;
	background-color: rgba(0, 0, 0, 0.5);
	-webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}

.loader {
	font-size: 128px;
	text-align: center;
}

.md-fab-sm {
	height: 40px !important;
	width: 40px !important;
	padding: 0px;
}

.md-fab-xs {
	height: 28px !important;
	width: 28px !important;
	line-height: 28px;
	padding: 0px;
}

.exit-button {
	margin: -8px -16px;
	width: 56px;
	height: 56px;
	text-align: center;
	cursor: pointer;
}
.exit-button:hover {
	background-color: rgba(0, 0, 0, 0.075);
}
.exit-button a {
	line-height: 56px;
}
.slow-color {
	transition: color 10s;
}
.dropdown-toggle {
	border-top-right-radius: 4px !important;
	border-bottom-right-radius: 4px !important;
}

.r-controls-overlay {
	/* height: 0; */
	position: absolute;
	left: 20px;
	top: 20px;
	opacity: 0;
	z-index: 20;
}
.resources:hover .r-controls-overlay {
	opacity: 1;
	height: auto;
}
.r-controls-overlay button {
	display: block;
	font-size: 20px;
	line-height: 2;
}
.r-controls-overlay .dropdown-item.active {
	color: inherit;
	background-color: rgba(0, 0, 0, 0.1);
}

.controls-overlay {
	opacity: 0;
	z-index: 20;
}
.viewer-viewport:hover ~ .controls-overlay,
.controls-overlay:hover {
	opacity: 1;
}

.toggles-overlay {
	opacity: 0;
}

.viewer-sidenav:hover ~ .toggles-overlay,
.resources:hover ~ .toggles-overlay,
.viewer-container:not(.show-sidenav):not(.show-resources) .toggles-overlay,
.toggles-overlay.show {
	opacity: 1;
}

@media (hover: none) {
	.toggles-overlay,
	.controls-overlay,
	.tabs-overlay {
		opacity: 1;
	}
}

/* .nav-tabs {
	flex-wrap: nowrap;
} */
.nav-item {
	background-color: #ffffff;
	min-width: 50px;
	overflow: hidden;
	white-space: nowrap;
	border-bottom: 1px solid rgba(120, 130, 140, 0.13);
	border-right: 1px solid rgba(120, 130, 140, 0.13);
	flex: 1 1 50px;
	text-align: center;
}
.nav-item > a {
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
}

.set-nav-footer {
	margin-left: -10px;
	margin-right: -10px;
	background-color: rgb(231, 231, 231);
}
</style>



// WEBPACK FOOTER //
// src/vues/Scoring/Viewer.vue